module.exports = __webpack_public_path__ + "img/syzxc02.73bb3e0f.png";